import React from 'react';
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';
import BlueBackgroundSVG from '../../../Layout/TitleWithUnderlineSubnav/BlueBackgroundSVG/BlueBackgroundSVG';

import './ZeroStateNeedLove.scss';

const ZeroStateNeedLove = () => {
    const injectedTransforms = {
        default: '',
    };
    return (
        <div className="zero-state-card">
            <div className="zero-state-display">
                <div className="zero-state-header">
                    Looks like there&apos;s a lot of love <br />
                    happening in the community!
                </div>
                <div className="zero-state-text">
                    It&apos;s nice of you to want to help. Try selecting
                    &quot;Recent
                    <br />
                    posts&quot; to support new posts on the feed.
                </div>
                <img
                    className="plant-svg"
                    src={buildImagePath(
                        '/v1559587230/Plant_uwlxll.svg',
                        'default',
                        injectedTransforms
                    )}
                    alt="plant-svg"
                />
                <BlueBackgroundSVG />
            </div>
        </div>
    );
};

export default ZeroStateNeedLove;
